import { render, staticRenderFns } from "./PortfolioComponent.vue?vue&type=template&id=79e851ef&"
import script from "./PortfolioComponent.vue?vue&type=script&lang=js&"
export * from "./PortfolioComponent.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports